<template>
  <el-drawer :visible="visible" :title="deductType === 'reduce' ? '减免' : ' 扣款'" @close="close">
    <el-row class="user-base-info" style="margin-bottom: 20px">
      <div>用户编号：{{ taskInfo.borrowerId }}</div>
      <div>用户姓名：{{ taskInfo.borrowerName }}</div>
    </el-row>
    <el-form ref="deductDialog" :model="deductDialog">
      <el-form-item :label="deductType === 'reduce' ? '减免金额' : ' 扣款金额'"  prop="amount">
        <el-input v-model.trim="deductDialog.amount" placeholder="请填写" style="width: 120px" />
      </el-form-item>
      <el-form-item v-if="deductType === 'reduce'" label="减免原因" >
        <el-select v-model="deductDialog.reason" style="width: 120px">
          <el-option label="系统原因" value="系统原因" />
          <el-option label="客户经济困难" value="客户经济困难" />
          <el-option label="结清减免" value="结清减免" />
          <el-option label="对公入账延迟" value="对公入账延迟" />
          <el-option label="投诉保险" value="投诉保险" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="deductType === 'reduce'" label="减免类型" >
        <el-select v-model="deductDialog.reduceType" style="width: 120px">
          <el-option label="有责减免" value="有责减免" />
          <el-option label="无责减免" value="无责减免" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button  @click="handleVisible">取 消</el-button>
        <el-button  type="primary" @click="handleDeduct('deductDialog')">确 定</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'item-dialog-deduct',
  props: {
    taskId: {
      type: [Number, String],
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    deductType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      deductDialogFormVisible: false,
      deductDialog: {
        amount: ''
      },
      paymentFlag: false
    }
  },
  computed: {
    ...mapGetters([
      'currentLoanItem',
      'taskInfo',
      'currentUser',
      'totalRepayAmount'
    ])
  },
  watch: {
    'visible'() {
      if (this.visible) {
        if (this.deductType === 'reduce') {
          this.deductDialog.amount = 0
        } else {
          this.deductDialog.amount = this.totalRepayAmount
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'deduct'
    ]),
    close() {
      this.$emit('hide')
    },
    handleVisible() {
      this.$emit('hide')
    },
    handleDeduct(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.paymentFlag) {
            if (Number(this.deductDialog.amount) === 0) return this.$message.error('金额不能为0')
            const params = {
              taskId: this.taskId,
              userId: this.taskInfo.borrowerId,
              opUserId: this.currentUser.id,
              loanMainId: this.taskInfo.loanId,
              amount: this.deductDialog.amount,
              paymentBizType: 4,
              source: 'BAOFU_PROTOCOL'
            }
            if (this.deductType === 'reduce') {
              params.paymentBizType = 6
              params.source = 'PRETTY_BREAKS'
            }
            this.paymentFlag = true
            this.deduct({ params }).then((res) => {
              this.deductDialogFormVisible = false
              this.$notify({
                title: res.data,
                message: '',
                duration: 0
              })
            })
            this.handleVisible()
          } else {
            this.$message.error('请勿重复操作')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
